<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择服务人员"
    style="width: 100%"
    multiple
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { userList } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    baseid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  watch: {
    baseid() {
      this.getList()
    },
  },
  created() {
    if (this.baseid) {
      this.getList()
    }
  },
  methods: {
    async getList() {
      let res = await userList({ base_id: this.baseid, status: 1 })
      if (res.status == 0) {
        this.lists = res.data.list
        let ids = this.value.filter((item) =>
          this.lists.some((list) => list.id == item)
        )
        if (ids.length != this.value.length) {
          this.$emit('input', ids)
        }
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>